/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {isEqual} from 'lodash-es';

/**
 * function for use in Array.filter().
 *
 * Usage:
 * Simple values or whole objects:
 * <code>
 *     const fixture = ['a', 1, 'a', 2, '1'];
 *     const result = fixture.filter(uniqueObjectFilter());
 * </code>
 *
 * using the valueExtractor (i.e.: only some properties of an object are evaluated):
 * <code>
 *     const input = [new Foo(a: 'a', b: 1), new Foo(a: 'a', b: 1), new Foo(a: 'x', b: 99)];
 *     const result = input.filter(uniqueObjectFilter<Foo>(x => x.a, x => x.b));
 * </code>
 */
export function uniqueFilter<T>(...valueExtractor: ((value: T) => any)[]):
    (value: T, index: number, array: T[]) => boolean {

    const extractors = valueExtractor.length ? valueExtractor : [(x: any) => x];

    return (value: T, index: number, array: T[]): boolean => {
        const foundIndex = array.findIndex(e =>
            extractors.map(extractor => isEqual(extractor(e), extractor(value)))
                .reduce((a, b) => a && b, true)
        );

        return foundIndex === index;
    };
}
